export default "__VITE_ASSET__B6cjhpo6__"